import {Component, OnInit} from '@angular/core';
import {setPropertyOnNotificationState, setRetryStockUpdate} from '../../../notifications/store/notification.actions';
import {Store} from '@ngrx/store';
import {logOutUser, setGlobalModalVisibility} from '../../../user-access/user-store/user.actions';
import {ModalType} from '../../models/modal-enums';
import {selectGlobalOpenModals} from '../../../user-access/user-store/user.selectors';
import {Observable} from 'rxjs';
import {selectViewChangesModalTitle} from '../../../notifications/store/notification.selectors';

@Component({
  selector: 'app-global-modal-container',
  templateUrl: './global-modal-container.component.html',
  styleUrls: ['./global-modal-container.component.scss'],
  standalone: false,
})
export class GlobalModalContainerComponent implements OnInit {

  modalEnum = ModalType;
  currentModal$: Observable<string[]>;
  viewChangesModalTitle$: Observable<string>;

  constructor(
    private readonly store: Store,
  ) {
  }

  ngOnInit(): void {
    this.currentModal$ = this.store.select(selectGlobalOpenModals);
    this.viewChangesModalTitle$ = this.store.select(selectViewChangesModalTitle);
  }

  onNotificationsClose(): void {
    // If cleared re initialize streams
    // this.store.dispatch(clearNotificationState({
    //   clearErrors: false,
    //   clearNotifications: true,
    // }));
    this.closeModals([]);
  }

  onCloseSignOutModal(): void {
    this.store.dispatch(setGlobalModalVisibility({visibility: false, modalType: []}));
  }

  onSignOutClick(): void {
    this.store.dispatch(logOutUser());
  }

  closeInnerModal(parentModal: string): void {
    this.closeModals([parentModal], true);
    this.store.dispatch(setPropertyOnNotificationState({property: 'stockViewChanges', value: {}}));
    this.store.dispatch(setRetryStockUpdate({retryStockUpdate: false, excludeFailedBarcodes: false}));
  }

  private closeModals(modalType: string[], visibility: boolean = false): void {
    this.store.dispatch(setGlobalModalVisibility({visibility, modalType}));
  }
}
